module.exports = __webpack_public_path__ + "img/leftside_1000.82d5e83f.png";